import Cookies from 'js-cookie';

/** First-party anon id cookie + event property (intended warehouse join key with ULF). */
export const PX_ANONYMOUS_ID_KEY = 'px_anonymous_id';

const COOKIE_DAYS = 365;

/**
 * Parent-domain cookie host for production only.
 * `www.smartalbums.com` / `auth.smartalbums.com` → `.smartalbums.com`.
 * Staging / prerelease (`*.px-dev.com`) and localhost omit `domain` (host-only cookie).
 */
export function parentCookieDomain(hostname = window.location.hostname) {
  const host = String(hostname || '').toLowerCase();
  if (host === 'smartalbums.com' || host.endsWith('.smartalbums.com')) {
    return '.smartalbums.com';
  }
  return undefined;
}

function createId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const rand = (Math.random() * 16) | 0;
    const value = char === 'x' ? rand : (rand & 0x3) | 0x8;
    return value.toString(16);
  });
}

/**
 * Read the first-party anonymous id from the cookie only.
 * Presence means the id is stored; absence means there is no join key.
 *
 * @returns {string|null}
 */
export function getPxAnonymousId() {
  if (typeof window === 'undefined') return null;
  return Cookies.get(PX_ANONYMOUS_ID_KEY) || null;
}

/**
 * Read or create the first-party anonymous id cookie.
 * Call on Gatsby route update so the cookie exists before any `track`.
 * Only returns an id after a successful cookie read-back; otherwise null
 * (no in-memory fallback — a warehouse join key must be cookie-backed).
 *
 * @returns {string|null}
 */
export function getOrCreatePxAnonymousId() {
  if (typeof window === 'undefined') return null;

  const existing = Cookies.get(PX_ANONYMOUS_ID_KEY);
  if (existing) return existing;

  const id = createId();
  const domain = parentCookieDomain();
  const options = { expires: COOKIE_DAYS, path: '/' };
  if (domain) options.domain = domain;

  Cookies.set(PX_ANONYMOUS_ID_KEY, id, options);
  if (Cookies.get(PX_ANONYMOUS_ID_KEY) === id) return id;

  return null;
}
